var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageHistorii(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5299V4.41992C18 3.88949 17.7893 3.38078 17.4142 3.00571C17.0391 2.63064 16.5304 2.41992 16 2.41992H11.82C11.4 1.25992 10.3 0.419922 9 0.419922C7.7 0.419922 6.6 1.25992 6.18 2.41992H2C0.9 2.41992 0 3.31992 0 4.41992V18.4199C0 18.9504 0.210714 19.4591 0.585786 19.8341C0.960859 20.2092 1.46957 20.4199 2 20.4199H8.11C9.37 21.6599 11.09 22.4199 13 22.4199C16.87 22.4199 20 19.2899 20 15.4199C20 13.5099 19.24 11.7899 18 10.5299ZM9 2.41992C9.55 2.41992 10 2.86992 10 3.41992C10 3.96992 9.55 4.41992 9 4.41992C8.45 4.41992 8 3.96992 8 3.41992C8 2.86992 8.45 2.41992 9 2.41992ZM2 18.4199V4.41992H4V6.41992H14V4.41992H16V9.09992C15.09 8.66992 14.08 8.41992 13 8.41992H4V10.4199H8.1C7.5 10.9899 7.04 11.6699 6.68 12.4199H4V14.4199H6.08C6.03 14.7499 6 15.0799 6 15.4199C6 16.4999 6.25 17.5099 6.68 18.4199H2ZM13 20.4199C10.24 20.4199 8 18.1799 8 15.4199C8 12.6599 10.24 10.4199 13 10.4199C15.76 10.4199 18 12.6599 18 15.4199C18 18.1799 15.76 20.4199 13 20.4199ZM13.5 15.6699L16.36 17.3599L15.61 18.5799L12 16.4199V11.4199H13.5V15.6699Z",
    fill: "#0F0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageHistorii);
export default __webpack_public_path__ + "static/media/messageHistorii.bf8e07baf6e30a9c2a00b443f0e63299.svg";
export { ForwardRef as ReactComponent };